module.exports = __webpack_public_path__ + "static/media/p2_s3.01ef5469.ogg";